import React from 'react';
import { Helmet } from 'react-helmet';
// import favicon from '../images/favicon.png';

export const SEO = ({
  children,
  location,
  description,
  title,
  image,
  noindex,
}) => {
  return (
    <Helmet>
      <html lang='en' />
      <title>{title}</title>

      {/* Meta Tags */}
      <meta name='viewport' content='width=device-width, initial-scale=1.0' />
      <meta name={`robots`} content={noindex ? `noindex, nofollow` : null} />
      <meta charSet='utf-8' />
      <meta name='description' content={description} />
      {/* Open Graph */}
      {location && <meta property='og:url' content={location.href} />}
      {/* <meta property='og:image' content={pestpacfavicon || '/logo.svg'} /> */}
      <meta property='og:title' content={title} key='ogtitle' />
      <meta propery='og:site_name' content={title} key='ogsitename' />
      <script async src='https://js.navattic.com/embeds.js'></script>
      {/* <link rel='icon' type='image/png' href={favicon} /> */}
      {children}
    </Helmet>
  );
};
